import script from "./YTableColumnSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./YTableColumnSetting.vue?vue&type=script&setup=true&lang=js"

import "./YTableColumnSetting.vue?vue&type=style&index=0&id=7a822804&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a822804"]])

export default __exports__